import React from 'react';
import { Grid, FormGroup, User } from '@mss/mss-component-library';
import TimeAgo from 'react-timeago';
import { useTranslation } from 'react-i18next';

type Props = {
  user: User;
};

export default function Settings({ user }: Props) {
  const [t] = useTranslation(['authorization', 'profile', 'common']);
  return (
    <Grid.Row>
      <Grid.Col width={4}>
        <FormGroup
          label={t('First name')}
          input={<>{user.first_name}</>}
        />
      </Grid.Col>
      <Grid.Col width={4}>
        <FormGroup
          label={t('Last name')}
          input={<>{user.last_name}</>}
        />
      </Grid.Col>
      <Grid.Col width={4}>
        <FormGroup
          label={t('Email address')}
          input={<>{user.email}</>}
        />
      </Grid.Col>
      <Grid.Col width={4}>
        <FormGroup label={t('User ID')} input={<>{user.id}</>} />
      </Grid.Col>
      <Grid.Col width={4}>
        <FormGroup
          label={t('Last login')}
          input={
            user.last_login ? (
              <TimeAgo date={user.last_login} />
            ) : (
              <>{t('Never')}</>
            )
          }
        />
      </Grid.Col>
    </Grid.Row>
  );
}
